// HOOKS
import { useContext, useState } from "react";
// COMPONENTS
import ActionBar from "../actionBar.component";
import CreateProductButton from "../../buttons/products/create.product.button";
import DefaultButton from "../../buttons/default.button";
import UploadProductsButton from "../../buttons/products/upload.products.button";
// CONTEXTS
import { ProductsContext } from "../../../contexts/products/products.context";

const CLASSNAMES = {
  button:
    "bg-red-500 hover:bg-red-700 shadow active:skew-y-0 hover:skew-y-3 shadow-secondary font-ubuntuBold rounded px-4 py-2 text-white",
};

const ProductActionBar = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { getProducts, deleteManyProducts, selected, resetSelected } =
    useContext(ProductsContext);
  const handleDeleteManyProducts = () => {
    if (isLoading) return;
    setIsLoading(true);
    if (selected.length === 0) return;
    deleteManyProducts(selected);
    resetSelected();
    setIsLoading(false);
    // Refresh products after 2 seconds
    setTimeout(() => {
      getProducts();
    }, 1500);
  };

  return (
    <ActionBar>
      {selected.length > 0 && (
        <DefaultButton
          classNames={CLASSNAMES}
          handleClick={handleDeleteManyProducts}
          loading={isLoading}
        >
          Delete {selected.length}
        </DefaultButton>
      )}
      <CreateProductButton onClose={getProducts} />
      <UploadProductsButton />
      {children}
    </ActionBar>
  );
};

export default ProductActionBar;
